// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"835":"12f2bfcb9226cf69","898":"fd8bfa2092c915b5"}[chunkId] + ".js";
};